import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DynamicIcon from "../../routes/DynamicIcon";
import MENU from "./menu.json";
import "./styles.css";
import { Layout } from "antd";
import Siders from "../../routes/sider";
import Header from "../../routes/Header";

function DashboardScreen() {
  const navigate = useNavigate();

  return (
    <Container fluid={true}>
      <br />
      <div className="DashboardScreen-row">
        <div>
          <div className="DashboardScreen-txt1">Good Morning,</div>
          <div className="DashboardScreen-txt2">Welcome to Admin Dashboard</div>
        </div>
        <div style={{ flex: 1 }} />
        <div className="DashboardScreen-txt3">{new Date().toDateString()}</div>
      </div>
      <br />
      <Row>
        {MENU?.map((item: any) => {
          return (
            <Col
              sm={3}
              key={item.head}
              onClick={() => navigate(item?.navigate)}
            >
              <div className="DashboardScreen-item">
                <div>
                  <DynamicIcon name={item.icon} size={30} color={"#b72c6f"} />
                </div>
                &nbsp; &nbsp;
                <div>
                  <div className="DashboardScreen-itemtxt1">{item?.head}</div>
                  <div className="DashboardScreen-itemtxt2">
                    {item?.description}
                  </div>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
}

export default DashboardScreen;
